export const azureConstants = {
	GetUserUsageMetricsRequest: "FETCH_USERUSAGE_METRICS_STARTED",
	GetUserUsageMetricsSuccess: "FETCH_USERUSAGE_METRICS_COMPLETED",
	GetUserUsageMetricsFailure: "FETCH_USERUSAGE_METRICS_FAILED",
	
}